import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Settings } from '../shared/models/settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {

  constructor(private http: HttpClient) { }

  get({ siteId }): Observable<Settings> {
    return this.http.get<Settings>(`api/sites/${siteId}/api/v1/setup/settings`);
  }
}
